import { Link } from 'react-router-dom';
import minDesEcoPro from '../../img/MinDesEcoPro.png';

const MinDesEcoPro = () => {
   return (
      <>
         <div className="section animated fadeIn" style={{ margin: '10px 0', padding: 0 }}>
            
            {/* BANNER INSTITUCIONAL DE ANCHO COMPLETO */}
            <div className="card-panel bg-latitud z-depth-2" style={{ borderRadius: '12px', padding: '40px 30px', backgroundColor: '#039be5', margin: 0 }}>
               <div className="row valign-wrapper" style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', margin: 0, maxWidth: '1400px', marginLeft: 'auto', marginRight: 'auto' }}>
                  
                  {/* IMAGEN / LOGO CON FONDO OSCURO PARA CONTRASTE */}
                  <div className="col s12 m12 l5 x5 center-align" style={{ marginBottom: '20px' }}>
                     <div style={{ display: 'inline-block', padding: '15px 20px', background: 'rgba(8, 22, 38, 0.45)', borderRadius: '10px', border: '1px solid rgba(255, 255, 255, 0.2)', boxShadow: '0 4px 12px rgba(0,0,0,0.15)' }}>
                        <Link to="https://proveedores.registrominero.jujuy.gob.ar/registro?filter[status][0]=6&filters[query]=LATITUD&page=1" target="_blank" rel="noopener noreferrer">
                           <img 
                              src={minDesEcoPro} 
                              alt="Registro Provincial de Proveedores Mineros Jujuy" 
                              className="responsive-img" 
                              style={{ maxHeight: '110px', objectFit: 'contain', display: 'block', margin: '0 auto' }} 
                           />
                        </Link>
                     </div>
                  </div>

                  {/* TEXTO Y BOTÓN DE ACCIÓN */}
                  <div className="col s12 m12 l7 x7 white-text center-on-small-only" style={{ paddingLeft: '15px' }}>
                     <strong style={{ fontSize: '1.25rem', lineHeight: '1.5', display: 'block', marginBottom: '20px', fontWeight: '600' }}>
                        Nos encontramos incluidos en el registro provincial de proveedores locales de empresas mineras
                     </strong>
                     <Link 
                        to="https://proveedores.registrominero.jujuy.gob.ar/registro?filter[status][0]=6&filters[query]=LATITUD&page=1" 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        className="btn waves-effect waves-light white grey-text text-darken-3 z-depth-1 hoverable" 
                        style={{ borderRadius: '6px', textTransform: 'none', fontWeight: '600', padding: '0 28px', height: '42px', lineHeight: '42px' }}
                     >
                        Visitar registro
                        <i className="material-icons right" style={{ fontSize: '1.2rem', marginLeft: '6px' }}>open_in_new</i>
                     </Link>
                  </div>

               </div>
            </div>

         </div>
      </>
   )
}

export default MinDesEcoPro